import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useCallback, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import { useItemProcessosRiscosFilters } from "../hooks/Qualidade_processos_riscos _itens/filter";
import { useItemProcessosRiscosPagination } from "../hooks/Qualidade_processos_riscos _itens/pagination";
import { QualidadeItemProcessosRiscosForm } from "../schemas/ProcessosRiscosItem/qualidade_processos_item";
import { ItemProcessoRiscosLista } from "../../domain/models/processos_riscos_item_lista";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useNavigate, useParams } from "react-router";

//LoadItemProcessosRiscosItensListaFuncState
type LoadItemProcessosRiscosItensListaFuncState = {
  IdItemProcesso?: number;
  page?: number;
  rowsPerPage?: number;
  tipoPesquisa?: number,
  pesquisa?: string | number | Date,
};

//useQualidadeitemProcessosRiscosListaViewModel

export const useQualidadeitemProcessosRiscosListaViewModel = () => {
  const {
    commons: {getFuncionariosDropDownUseCase },
    reports: {},
    qualidade: { getAllListagemItemProcessoRiscosUseCase, deleteItemProcessosRiscosUseCase}
   
  } = useDependencyInjection();

  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [ItemProcessosRiscosModal, setItemProcessosRiscosModal] = useState<boolean>(false);
  const [itemProcessosRiscosLista, setitemProcessosRiscosLista] = useState<ItemProcessoRiscosLista[]>([])
  const [selectedItemProcessosRiscos, setselectedItemProcessosRiscos] = useState<ItemProcessoRiscosLista>();
  const [ItemProcessosRiscosDeleteModal, setItemProcessosRiscosDeleteModal] = useState<boolean>(false);
  const {pushErrorNotification, pushInfoNotification } = usePageLoader();
  const debouncedRef = useCreateDebounceHandler(750);
  const {  id } = useParams(); 
  const filters = useItemProcessosRiscosFilters();
  const pagination = useItemProcessosRiscosPagination();
  const navigate = useNavigate();

  // #region Funções de carregamento

  const loadItemProcessoRiscosListaState = useCallback(async (funcState?: LoadItemProcessosRiscosItensListaFuncState) => {
    try {
        setLoading(true);
        if(id){
          const filterID_IdItemProcesso = evaluateParamValue(funcState?.IdItemProcesso, filters.IdItemProcesso);
          const filteredTipoPesquisa = funcState?.tipoPesquisa ?? filters.tipoPesquisa;
          const filteredPage = funcState?.page ?? pagination.page;
          const filteredRowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;
          const filteredPesquisa = funcState?.pesquisa ?? filters.pesquisa;
          await getAllListagemItemProcessoRiscosUseCase.getAllListagemItemProcessoRiscos(
            {
              IdItemProcesso: filterID_IdItemProcesso, IdProcesso: Number(id), Pesquisar: String(filteredPesquisa ) , PesquisarPor: filteredTipoPesquisa
            },
            filteredPage,
            filteredRowsPerPage
           );

          setitemProcessosRiscosLista(getAllListagemItemProcessoRiscosUseCase.items);
          pagination.setRowsPerPage(getAllListagemItemProcessoRiscosUseCase.pageSize);
          pagination.setTotalItems(getAllListagemItemProcessoRiscosUseCase.totalItems);
          setLoading(false);
        }
         
      } catch (e: unknown) {
        setLoading(false);
        throw new Error("Falha ao Item Processo Risco Lista!");
      }
    }, [filters.IdItemProcesso, filters.pesquisa, filters.tipoPesquisa, getAllListagemItemProcessoRiscosUseCase, id, pagination]);

  const loadFuncionariosDropDown = useCallback(async () => {
      try {
        const funcionarios = await getFuncionariosDropDownUseCase.getFuncionariosDropDown();
        useItemProcessosRiscosFilters.setState({ funcionariosLista: funcionarios });
      } catch (e: unknown) {
        useItemProcessosRiscosFilters.setState({ funcionariosLista: [] });
        throw e;
      }
    }, [  getFuncionariosDropDownUseCase ]);
  

  //#endregion

  // #region useEffect
  usePageStartBootstrap(async () => {
    try {
      const jobs = [];
      jobs.push(loadFuncionariosDropDown());
      jobs.push(loadItemProcessoRiscosListaState());
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, 'Falha ao buscar dados da pagina!')[0]);
    }
  });

  const handleReload = useCallback(async () => {
    try {
      const jobs = [];
      setLoading(true);
      jobs.push(loadItemProcessoRiscosListaState());
      jobs.push(loadFuncionariosDropDown());
      
      await Promise.all(jobs);
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadFuncionariosDropDown, loadItemProcessoRiscosListaState, pushErrorNotification]);
  //#endregion

  // #region Eventos

  const handleItemProcessosRiscosSubmit = useCallback(async (form: QualidadeItemProcessosRiscosForm) => {
    try {
      if(selectedItemProcessosRiscos ){
        setItemProcessosRiscosModal(false);
        pushInfoNotification("Sucesso", "Processo Riscos atualizado com sucesso!", { isAutoFinish: true });
      }else{
        setItemProcessosRiscosModal(false);
        pushInfoNotification("Sucesso", "Processo Riscos criado com sucesso!", { isAutoFinish: true });
      }
      loadItemProcessoRiscosListaState();
    } catch (e) {
        pushErrorNotification("Erro", processError(e, 'Falha ao criar/atualizar Processo Risco!'));
    }finally {
      setSaving(false);
    }
  },[loadItemProcessoRiscosListaState, pushErrorNotification, pushInfoNotification, selectedItemProcessosRiscos]);

  const handleCadastroItemProcessoRiscosOpenState = useCallback((IdItemProcesso: number | null, openState: boolean) => {
    if (openState) {
      if (IdItemProcesso) {
        navigate(`/ProcessosRiscos_cadastroitens/${id}/${IdItemProcesso}`)
      } else {
        setselectedItemProcessosRiscos(undefined);
      }
    }
    setItemProcessosRiscosModal(openState);
  }, [id, navigate]);

  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);;
      await loadItemProcessoRiscosListaState({page: page + 1,});
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadItemProcessoRiscosListaState, pagination, pushErrorNotification]);

  
  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
        setLoading(true);
        pagination.setPage(1);
        pagination.setRowsPerPage(rowsPerPage);
  
        await loadItemProcessoRiscosListaState({ page: 1, rowsPerPage });
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadItemProcessoRiscosListaState, pagination, pushErrorNotification]);

   const handleDeleteItemProcessoRiscosModalOpenState = useCallback((IdItemProcesso: number | null, openState: boolean) => {
    if (openState) {
      if (IdItemProcesso && itemProcessosRiscosLista) {
        setselectedItemProcessosRiscos(itemProcessosRiscosLista.find(x => x.IdItemProcesso === IdItemProcesso));
      } else {
        setselectedItemProcessosRiscos(undefined);
      }
    }
    setItemProcessosRiscosDeleteModal(openState);
  }, [itemProcessosRiscosLista]);
  

  const handleDeleteConfirmaItemProcessosRiscos = useCallback(async () => {
    if (selectedItemProcessosRiscos) {        
      try {
          setSaving(true);
          await deleteItemProcessosRiscosUseCase.deleteItemProcessoRiscos(selectedItemProcessosRiscos.IdItemProcesso, selectedItemProcessosRiscos.IdProcesso);
          await loadItemProcessoRiscosListaState();
          pushInfoNotification("Sucesso", "Item Processo Riscos excluido com sucesso!", { isAutoFinish: true });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, 'Falha ao excluir informações!'));
        } finally {
          setSaving(false);
          setItemProcessosRiscosDeleteModal(false);
        }
      }
  }, [deleteItemProcessosRiscosUseCase, loadItemProcessoRiscosListaState, pushErrorNotification, pushInfoNotification, selectedItemProcessosRiscos]);


  //#endregion



  //#region Filtros
  const handleClearFilters = useCallback(async () => {
    try {
        setLoading(true);
        filters.clearFilters();
        pagination.setPage(1);
        await loadItemProcessoRiscosListaState({pesquisa: "", tipoPesquisa: 0});
    } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao buscar Itens Processo Riscos!'));
    } finally {
        setLoading(false);
    }
  }, [filters, loadItemProcessoRiscosListaState, pagination, pushErrorNotification]);

  const handlePesquisaChange = useDebouncedCallback( debouncedRef,  (newValue: string | number |null) => {
    useItemProcessosRiscosFilters.getState().setPesquisa(newValue);
    
    if (newValue) {
      return async () => {
        try {
          setLoading(true);
          useItemProcessosRiscosPagination.getState().setPage(1);
          await loadItemProcessoRiscosListaState({ pesquisa: newValue, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao carregar Processo Riscos!"));
        } finally {
          setLoading(false);
        }
      }
    } else {
      return async () => {
        try {
          setLoading(true);
          useItemProcessosRiscosPagination.getState().setPage(1);
          await loadItemProcessoRiscosListaState(); 
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao carregar Provisao Recursos!"));
        } finally {
          setLoading(false);
        }
      }
    }
  }, 
    [ loadItemProcessoRiscosListaState, pushErrorNotification, setLoading]
  );

  const handleTipoPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useItemProcessosRiscosFilters.getState().setTipoPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useItemProcessosRiscosPagination.getState().setPage(1);
        await loadItemProcessoRiscosListaState({ tipoPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao buscar Item de processo de riscos!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadItemProcessoRiscosListaState, pushErrorNotification]);


  //#endregion
  const handleVoltar = useCallback(() => {
    navigate(`/ProcessosRiscos_lista/`)
      
  }, [id, navigate]);
  

  return {
      loading,
      saving,
      errorMessage,
      pagination,
      filters,
      itemProcessosRiscosLista,
      ItemProcessosRiscosDeleteModal,
      selectedItemProcessosRiscos,
      ItemProcessosRiscosModal,
      id,
      handleReload,
      handleVoltar,
      handleRowsPerPageChange,
      handlePageChange,
      handlePesquisaChange,
      handleClearFilters,
      handleDeleteItemProcessoRiscosModalOpenState, 
      handleDeleteConfirmaItemProcessosRiscos,
      handleCadastroItemProcessoRiscosOpenState,
      handleItemProcessosRiscosSubmit,
      handleTipoPesquisaChange,
  }
}